module.exports = __webpack_public_path__ + "media/images/icon_list/volume-d6167602e10489d4f86eabc8717089b5.svg";